import { Button, Col, Row } from "react-bootstrap";
import React, { Dispatch, SetStateAction, useState } from "react";
import { toast } from "react-toastify";
import { TYPE_KE_HOACH_DAO_TAO } from "../../../../quan-ly-khao-sat/Components/danh-sach-ke-hoach/constants/constansKeHoach";
import TableNhanLuc from "./TableNhanLuc";
import LabelRequired from "../../../../component/LabelRequired";
import TextField from "../../../../component/TextField";

interface Props {
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>;
  dataTrangThietBi: any[];
  setDataTrangThietBi: Dispatch<SetStateAction<any[]>>;
  isView?: boolean;
}

const NDLyThuyet = (props: Props) => {
  const { dataTrangThietBi, setDataTrangThietBi, isView } = props;

  const [noiDung, setNoiDung] = useState<string>('');
  const [thoiGianLT, setThoiGianLT] = useState<string>('');
  const [thoiGianTH, setThoiGianTH] = useState<string>('');
  const [tongThoiGian, setTongThoiGian] = useState<string>('N/A');
  const [editingIndex, setEditingIndex] = useState<number | null>(null);

  // Calculate total time when LT or TH changes
  React.useEffect(() => {
    const lt = parseFloat(thoiGianLT) || 0;
    const th = parseFloat(thoiGianTH) || 0;
    const total = lt + th;
    setTongThoiGian(total > 0 ? total.toString() : 'N/A');
  }, [thoiGianLT, thoiGianTH]);

  const handleAddOrUpdate = () => {
    if (!noiDung || !thoiGianLT || !thoiGianTH) {
      toast.warning('Vui lòng điền đầy đủ thông tin');
      return;
    }

    const newItem = {
      noiDung,
      thoiGianLT,
      thoiGianTH,
      tongThoiGian
    };

    if (editingIndex !== null) {
      const updatedList = [...dataTrangThietBi];
      updatedList[editingIndex] = newItem;
      setDataTrangThietBi(updatedList);
      setEditingIndex(null);
      toast.success('Cập nhật thành công');
    } else {
      setDataTrangThietBi([newItem, ...dataTrangThietBi]);
      toast.success('Thêm thành công');
    }

    setNoiDung('');
    setThoiGianLT('');
    setThoiGianTH('');
    setTongThoiGian('N/A');
  };

  const handleEdit = (row: any, index: number) => {
    setNoiDung(row.noiDung || '');
    setThoiGianLT(row.thoiGianLT || '');
    setThoiGianTH(row.thoiGianTH || '');
    setTongThoiGian(row.tongThoiGian || 'N/A');
    setEditingIndex(index);
  };

  const handleDelete = (index: number) => {
    const updatedList = dataTrangThietBi.filter((_: any, i: number) => i !== index);
    setDataTrangThietBi(updatedList);
    toast.success('Xóa thành công');
  };

  const columnsDkDaoTao = [
    {
      name: "STT",
      field: "",
      headerStyle: { width: 80 },
      cellStyle: { textAlign: "center" },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView
      ? [
        {
          name: "Thao tác",
          field: "",
          headerStyle: { width: 100 },
          cellStyle: { textAlign: "center", justifyContent: "center" },
          render: (row: any, index: number) => (
            <div className="d-flex justify-content-center">
              <i
                onClick={() => handleEdit(row, index)}
                className="bi bi-pencil-square text-navy cursor-pointer"
                style={{ cursor: 'pointer', marginRight: '10px' }}
              ></i>
              <i
                onClick={() => handleDelete(index)}
                className="bi bi-trash3-fill text-danger cursor-pointer"
                style={{ cursor: 'pointer' }}
              ></i>
            </div>
          ),
        },
      ]
      : []),
    {
      name: "Nội dung",
      field: "noiDung",
      headerStyle: { minWidth: 200 },
      cellStyle: { textAlign: "left" },
      render: (row: any) => row.noiDung || '',
    },
    {
      name: "Thời gian LT",
      field: "thoiGianLT",
      headerStyle: { minWidth: 120 },
      cellStyle: { textAlign: "center" },
      render: (row: any) => row.thoiGianLT || '',
    },
    {
      name: "Thời gian TH",
      field: "thoiGianTH",
      headerStyle: { minWidth: 120 },
      cellStyle: { textAlign: "center" },
      render: (row: any) => row.thoiGianTH || '',
    },
    {
      name: "Tổng thời gian",
      field: "tongThoiGian",
      headerStyle: { minWidth: 120 },
      cellStyle: { textAlign: "center" },
      render: (row: any) => row.tongThoiGian || 'N/A',
    },
  ];

  return (
    <div className="">
      <div className="spaces 2 title">
        <span className="text-title fw-bold fs-5 spaces mb-5 mt-20">
          Nội dung lý thuyết
        </span>
      </div>
      <Row>
        <Col lg={1} className="spaces">
          <div className="spaces pt-10">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="Nội dung" />
            </div>
          </div>
        </Col>
        <Col lg={11} className="spaces pt-8">
          <TextField
            name="noiDung"
            type="text"
            onChange={(e: any) => setNoiDung(e.target.value)}
            value={noiDung}
            disabled={isView}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col lg={1} className="spaces">
          <div className="spaces pt-10">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="Thời gian LT" />
            </div>
          </div>
        </Col>
        <Col lg={3} className="spaces pt-8">
          <TextField
            name="thoiGianLT"
            type="text"
            onChange={(e: any) => setThoiGianLT(e.target.value)}
            value={thoiGianLT}
            disabled={isView}
          />
        </Col>
        <Col lg={1} className="spaces">
          <div className="spaces pt-10">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="Thời gian TH" />
            </div>
          </div>
        </Col>
        <Col lg={3} className="spaces pt-8">
          <TextField
            name="thoiGianTH"
            type="text"
            onChange={(e: any) => setThoiGianTH(e.target.value)}
            value={thoiGianTH}
            disabled={isView}
          />
        </Col>
        <Col lg={1} className="spaces">
          <div className="spaces pt-10">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="Tổng thời gian" />
            </div>
          </div>
        </Col>
        <Col lg={3} className="spaces pt-8">
          <TextField
            name="tongThoiGian"
            type="text"
            value={tongThoiGian}
            disabled={true}
          />
        </Col>
      </Row>
      {!isView && (
        <div className="flex mt-10 spaces items-center">
          <Button
            className="btn-fill spaces min-w-90px btn btn-primary"
            onClick={handleAddOrUpdate}
            type="button"
          >
            <i className="bi bi-plus-lg text-pri fs-3"></i>
            {editingIndex !== null ? 'Cập nhật' : 'Thêm'}
          </Button>
          {editingIndex !== null && (
            <Button
              className="btn-fill spaces min-w-90px btn btn-secondary ml-2"
              onClick={() => {
                setEditingIndex(null);
                setNoiDung('');
                setThoiGianLT('');
                setThoiGianTH('');
                setTongThoiGian('N/A');
              }}
              type="button"
            >
              Hủy
            </Button>
          )}
        </div>
      )}
      <TableNhanLuc
        columns={columnsDkDaoTao}
        isView={isView}
        dsItems={dataTrangThietBi ?? []}
      />
    </div>
  );
};

export default NDLyThuyet;